module.exports = __webpack_public_path__ + "citibike.7cdfd8e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/images/neighborhood/full/citibike.jpg
// module id = 654
// module chunks = 0